console.log('ENV:', process.env.NODE_ENV);
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
} else {
  console.clear = () => {
    console.log('--- CONSOLE CLEAR wrapper on dev ---');
  };
}
